import axios from 'axios'

export const httpApiSisDev = axios.create({
  baseURL: process.env.VUE_APP_API_SISDEV
})